<script>
export default {
  name: 'StatCard',
  emits: [],
  mixins: [],
  props: {
    title: { type: String, required: true },
    value: { required: true },
    icon: { type: String, required: true },
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<template>
  <div class="flex flex-row p-4 content-center rounded-xl border bg-white">
    <font-awesome-icon class="icon" :icon="icon"/>
    <div class="text-area">
      <div class="text text-slate-500">{{ title}}</div>
      <div class="value-text">{{ value}}</div>
    </div>
  </div>
</template>

<style scoped>
.icon {
  @apply pr-4 w-8 h-8 mt-1;
}

.text-area {
  @apply flex flex-col gap-1.5;
}

.value-text {
  @apply pr-4;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
}

.text {
  font-size: 12px;
  letter-spacing: 1px;
  line-height: 14px;
  text-transform: uppercase;
}
</style>
